import { render, staticRenderFns } from "./VarietyInfoText.vue?vue&type=template&id=c9942cba&scoped=true&"
import script from "./VarietyInfoText.vue?vue&type=script&lang=js&"
export * from "./VarietyInfoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9942cba",
  null
  
)

export default component.exports